import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { UntypedFormArray } from '@angular/forms';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-calendario-importar-verificar',
  standalone: false,
  templateUrl: './calendario-importar-verificar.component.html',
  styleUrls: ['../calendario.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CalendarioImportarVerificarComponent implements OnInit {

  @Input()
  form: UntypedFormArray;
  @Input()
  propiedad: string;
  @Input()
  aEmparejar: string;
  @Input()
  objetos: any[];
  @Input()
  opciones$: Observable<any[]>;

  objetosFiltrados: any[];

  constructor() { }

  ngOnInit(): void {
    this.objetos = this.objetos.sort((a, b) => a.position - b.position);
    this.opciones$.subscribe(res => {
      this.objetosFiltrados = this.objetos.filter((item, index) => {
        item[this.propiedad] = res.find(obj => obj.id === this.form.at(index).get('id').value);
        return this.form.at(index).get('check').value;
      });
    });
  }

}
